import React from 'react';
import PropTypes from 'prop-types';

const Loading = ({ isVisible }) => (
  <div>{isVisible ? <div className="spinner-border text-primary"></div> : ''}</div>
);

Loading.defaultProps = {
  isVisible: 0
};

Loading.propTypes = {
  isVisible: PropTypes.number
};

export default Loading;
